import React from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
// import { Paper, Typography } from "@mui/material";

import axiosHandler from "../../../utils/axiosHandler.ts";
import { LoadBoardPage } from "../../../federation/pages";

const LoadBoard = () => {
  const navigate = useNavigate();

  return (
    <React.Suspense fallback={<CircularProgress />}>
      <LoadBoardPage axiosHandler={axiosHandler} navigate={navigate} />
    </React.Suspense>
  );
};

export default LoadBoard;
